import { TICKS_PER_BEAT } from '../../shared/tempo';
import type { EnemyDefinition } from '../types';

export interface StingEffect {
  readonly kind: 'sting';
  readonly everyBars: number;
  readonly flightBeats: number;
  readonly radius: number;
  readonly damage: number;
  readonly slowFactor: number;
  readonly slowBars: number;
  readonly heal: number;
}

export const MOUSTIQUES: EnemyDefinition = {
  id: 'moustiques',
  name: 'Les Moustiques',
  description: 'Une tête de moustique et sa nuée, qui pique et revient gorgée.',
  behaviour: 'boss',
  maxHp: 2000,
  speed: 0.9,
  radius: 48,
  damage: 30,
  attackCooldownTicks: 2 * TICKS_PER_BEAT,
  aggroRadius: 320,
  vibesDrop: 50,
  scalingPerPhrase: { hp: 1, speed: 1 },
  passable: true,
  special: {
    kind: 'sting',
    everyBars: 2,
    flightBeats: 2,
    radius: 48,
    damage: 8,
    slowFactor: 0.5,
    slowBars: 1,
    heal: 0.05,
  },
};
